import {
    addProductsToSegment,
    addSegment,
    createReport,
    deleteProduct,
    deleteReport,
    deleteSegment,
    fetchAllReports,
    fetchReport,
    updateReportName,
    updateSegment,
    updateProduct,
    // selectProducts,
    // unselectProducts,
} from './utils';
import Types from './types';
import * as actions from './actions';

const suggestionMiddleware = ({
    dispatch,
    getState
}) => (next) => async (action) => {
    const isLoading = getState().marketData.get('isLoading');

    next(action);
    try {
        if (Types.FETCH_REPORT === action.type) {
            if (!isLoading) {
                dispatch(actions.setLoader());
            }
            fetchReport(action.payload).then((res) => dispatch(actions.updateReport(res)));
        } else if (Types.FETCH_ALL_REPORTS === action.type) {
            if (!isLoading) {
                dispatch(actions.setLoader());
            }
            fetchAllReports().then((res) => dispatch(actions.updateReportList(res)));
        } else if (Types.MOVE_PRODUCT_TO_SEGMENT === action.type) {
            if (!isLoading) {
                dispatch(actions.setLoader());
            }
            const { productId, segmentId } = action.payload;
            updateProduct(productId, segmentId).then((res) => {
                dispatch(actions.updateReport(res));
            });
        } else if (Types.ADD_PRODUCTS_TO_SEGMENT === action.type) {
            if (!isLoading) {
                dispatch(actions.setLoader());
            }
            const { asins, segmentId } = action.payload;
            addProductsToSegment(segmentId, asins).then((res) => {
                dispatch(actions.updateReport(res));
            });
        } else if (Types.UPDATE_REPORT_NAME === action.type) {
            if (!isLoading) {
                dispatch(actions.setLoader());
            }
            updateReportName(action.payload).then((res) => dispatch(actions.updateReport(res)));
        } else if (Types.DELETE_PRODUCT === action.type) {
            if (!isLoading) {
                dispatch(actions.setLoader());
            }
            deleteProduct(action.payload).then((res) => dispatch(actions.updateReport(res)));
        } else if (Types.UPDATE_SEGMENT === action.type) {
            const { id, data } = action.payload;
            updateSegment(id, data).then((res) => dispatch(actions.updateReport(res)));
        } else if (Types.DELETE_SEGMENT === action.type) {
            deleteSegment(action.payload).then((res) => dispatch(actions.updateReport(res)));
        } else if (Types.DELETE_REPORT === action.type) {
            deleteReport(action.payload);
        } else if (Types.ADD_SEGMENT === action.type) {
            if (!isLoading) {
                dispatch(actions.setLoader());
            }
            const { segmentsReportId, data } = action.payload;
            addSegment(segmentsReportId, data)
                .then((res) => dispatch(actions.updateReport(res)));
        } else if (Types.CREATE_REPORT === action.type) {
            createReport(action.payload).then((res) => dispatch(actions.updateReport(res)));
        }
    } catch (err) {
        // console.error(err);
    }
};

export default suggestionMiddleware;
